import type { Logger } from '../types'

// Default runtime logger handed to service handlers as `logger`. Service code uses `logger.debug/info`
// for redacted tracing; only warn/error surface to the console by default (matching the no-bare-console
// policy). A host can supply its own Logger to route these elsewhere.
 
export const defaultLogger: Logger = {
  debug: () => {},
  info: () => {},
  warn: (...args: unknown[]) => console.warn(...args),
  error: (...args: unknown[]) => console.error(...args),
}
 
